export const trendingTopics = [
  { id: "t1", title: "深夜片场暖心一幕被拍下", heat: "328.6万", tag: "星闻" },
  { id: "t2", title: "话题剧收官夜三个隐藏细节", heat: "296.1万", tag: "剧集" },
  { id: "t3", title: "追剧该不该开倍速引发两派争论", heat: "271.4万", tag: "热议" },
  { id: "t4", title: "综艺现场罕见安静三秒", heat: "238.9万", tag: "综艺" },
  { id: "t5", title: "巡演首站压轴曲目全场大合唱", heat: "205.3万", tag: "现场" },
  { id: "t6", title: "红毯造型今年最出圈配色盘点", heat: "187.7万", tag: "穿搭" },
  { id: "t7", title: "小成本剧靠口碑逆袭出圈", heat: "162.5万", tag: "剧集" },
  { id: "t8", title: "音乐节新手最容易踩的几个坑", heat: "141.2万", tag: "现场" },
];

export const discussionBoard = [
  {
    id: "d1",
    title: "你追剧时会开倍速吗？说说你的理由",
    replies: 2410,
    tag: "热议话题",
  },
  {
    id: "d2",
    title: "有没有一部剧让你看完之后久久缓不过来",
    replies: 1876,
    tag: "剧集热评",
  },
  {
    id: "d3",
    title: "综艺里哪个瞬间让你觉得「这才是真人」",
    replies: 1329,
    tag: "综艺高能",
  },
  {
    id: "d4",
    title: "第一次去演唱会/音乐节，你最想提醒后来者什么",
    replies: 968,
    tag: "舞台现场",
  },
  {
    id: "d5",
    title: "有哪些红毯配色思路真的可以穿进日常",
    replies: 742,
    tag: "红毯穿搭",
  },
  {
    id: "d6",
    title: "你最近一次被热搜骗到是什么时候",
    replies: 615,
    tag: "网络热议",
  },
];

export const testimonials = [
  {
    name: "阿泽",
    role: "两年老瓜友",
    text: "最喜欢它的筛选，点开就能只看到自己想追的那一类，不用在乱七八糟的信息里翻来翻去，通勤路上十分钟能刷完当天热点。",
  },
  {
    name: "小满",
    role: "追剧党",
    text: "剧集热评这块写得很克制，很少见地不剧透关键情节，但又能把细节讲清楚，看完再回去二刷真的会有新发现。",
  },
  {
    name: "老周",
    role: "综艺爱好者",
    text: "每周更新挺稳的，名场面复盘速度很快，朋友群里讨论的内容基本都能在这里找到来源，省了不少自己到处找的时间。",
  },
  {
    name: "栗子",
    role: "穿搭关注者",
    text: "红毯穿搭栏目是我意外发现的宝藏，它不只是看图，还会把配色逻辑拆开讲，作为普通人照着搭真的能用上。",
  },
];

export const faqs = [
  {
    q: "「诱惑吃瓜」上的内容主要来自哪里？",
    a: "我们的内容由编辑团队根据公开可见的娱乐资讯、节目花絮与网络讨论整理编写，并标注所属栏目。所有稿件都经过二次梳理，力求把来龙去脉讲清楚，而不是简单地搬运素材。",
  },
  {
    q: "网站多久更新一次？",
    a: "首页头条与热榜通常每日更新，栏目内容会随着热点出现随时补充。遇到大型活动或剧集收官，我们也会加急跟进，尽量让你在第一时间看到整理好的版本。",
  },
  {
    q: "为什么有的内容看起来和下架前不太一样？",
    a: "当事件出现新的进展时，我们会对原稿进行补充或修正，并在更新时间上体现出来。与其抢一时的新鲜，我们更希望留在页面上的信息是准确、经得起回看的。",
  },
  {
    q: "我可以在网站上投稿或提供线索吗？",
    a: "当然可以。你可以在「关于我们」页面找到投稿入口，简要写明事情经过和可核实的来源即可。我们会在核实后决定是否采用，并尽量回复每一封邮件。",
  },
  {
    q: "网站上的观点代表谁？",
    a: "栏目中的评论与分析仅代表作者个人观察，不代表任何机构立场。涉及他人时我们会尽量避免主观定性，也欢迎你在评论区提出不同看法。",
  },
  {
    q: "内容可以转载吗？",
    a: "欢迎以链接形式分享。若需整篇转载，请先通过页面上的联系方式与我们沟通，并在显著位置注明出处，尊重原作者的劳动成果。",
  },
];